module.exports = __webpack_public_path__ + "img/83.b757a99b.png";